import { getIcingValueTexts, getVisibilityValueTexts, WeatherLimits } from "../utils/weather-limits";

export interface WeatherLimitElement
{
    name: keyof weatherlimit;
    text: string;
    unit?: string;
    min?: number;
    max?: number;
    connectedTo?: keyof weatherlimit;
    dropdown?: string[];
}


export const keysToConvert = [
     "wind10M",
     "wind50M",
     "windGusts10M",
     "windGusts50M",
     "riskWindSpeed",
];

export interface weatherlimit {
    wind10M: number | null; 
    wind50M: number | null;
    windGusts10M: number | null;
    windGusts50M: number | null;
    riskWindSpeed: number | null;
    waves: number | null;
    riskWaveHeight: number | null;
    headWavesHeight: number | null;
    headWavesPeriod: {
     max: number | null;
     min: number | null;
    },
    beamWavesHeight: number | null;
    beamWavesPeriod: {
         max: number | null;
         min: number | null;
    },
    followingWavesHeight: number | null;
    followingWavesPeriod: {
         max: number | null;
         min: number | null;
    },
    visibility: number | null;
    icing: number | null;
    hurricanes: number | null;
    tropicalStorms: number | null;
    depressions: number | null;
    iceConcentration: number | null;
    headWind: number | null;
    beamWind: number | null;
    followingWind: number | null;  
    maxRollAngle: number | null; // Optional property for roll angle limit

    // Swell fields
    swellHeight: number | null;
    headSwellHeight: number | null;
    headSwellPeriod: {
        max: number | null;
        min: number | null;
    };
    beamSwellHeight: number | null;
    beamSwellPeriod: {
        max: number | null;
        min: number | null;
    };
    followingSwellHeight: number | null;
    followingSwellPeriod: {
        max: number | null;
        min: number | null;
    };
}

export const WEATHER_LIMIT_DATA: weatherlimit = {
 wind10M: null,
 wind50M: null,
 windGusts10M: null,
 windGusts50M: null,
 riskWindSpeed: null,
 waves: null,
 riskWaveHeight: null,
 headWavesHeight: null,
 headWavesPeriod: {
  max: null,
  min: null,
 },
 beamWavesHeight: null,
 beamWavesPeriod: {
  max: null,
  min: null,
 },
 followingWavesHeight: null,
 followingWavesPeriod: {
  max: null,
  min: null,
 },
 visibility: null,
 icing: null,
 hurricanes: null,
 tropicalStorms: null,
 depressions: null,
 iceConcentration: null,
 headWind: null,
 beamWind: null,
 followingWind: null,
 maxRollAngle: null,
 // Swell fields
 swellHeight: null,
 headSwellHeight: null,
 headSwellPeriod: { max: null, min: null },
 beamSwellHeight: null,
 beamSwellPeriod: { max: null, min: null },
 followingSwellHeight: null,
 followingSwellPeriod: { max: null, min: null },
}

export const ELEMENT_DATA: WeatherLimitElement[] =[
     // Hurricanes, TropicalStorms and Depressions disabled for now, since we currently have no data to support them
            /*{
                name: "Hurricanes",
                text: "Minimum distance to hurricanes (nm.)",
                unit: "nm",
                min: 200
            },
            {
                name: "TropicalStorms",
                text: "Distance to tropical storms (nm.)",
                unit: "nm",
                min: 150
            },
            {
                name: "Depressions",
                text: "Distance to tropical depressions (nm.)",
                unit: "nm",
                min: 100
            },*/
            {
               name: "maxRollAngle",
               text: "Maximum roll angle (deg)",
               unit: "degrees",
               max: 20,
               min: 5,
            },
            {
               name: "wind10M",
               text: "Maximum wind speed 10m (m/s)",
               unit: "m/s",
               max: 30,
           },
           {
               name: "wind50M",
               text: "Maximum wind speed 50m (m/s)",
               unit: "m/s",
               max: 30,
           },
           {
               name: "windGusts10M",
               text: "Maximum wind gusts 10m (m/s)",
               unit: "m/s",
               max: 30,
           },
           {
               name: "windGusts50M",
               text: "Maximum wind gusts 50m (m/s)",
               unit: "m/s",
               max: 30,
           },
           {
               name: "riskWindSpeed",
               text: "Maximum risk wind speed (m/s)",
               unit: "m/s",
               max: 30,
           },
           {
               name: "waves",
               text: "Maximum wave height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "swellHeight",
               text: "Swell height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "headSwellHeight",
               text: "Head Swell height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "headSwellPeriod",
               text: "Head Swell period (sec)",
               unit: "sec",
               connectedTo: "headSwellHeight",
               max: 20,
           },
           {
               name: "beamSwellHeight",
               text: "Beam Swell height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "beamSwellPeriod",
               text: "Beam Swell period (sec)",
               unit: "sec",
               connectedTo: "beamSwellHeight",
               max: 20,
           },
           {
               name: "followingSwellHeight",
               text: "Following Swell height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "followingSwellPeriod",
               text: "Following Swell period (sec)",
               unit: "sec",
               connectedTo: "followingSwellHeight",
               max: 20,
           },
           {
               name: "riskWaveHeight",
               text: "Maximum risk wave height (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "headWavesHeight",
               text: "Head waves, higher than (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "headWavesPeriod",
               text: "with periods from (sec)",
               unit: "sec",
               connectedTo: "headWavesHeight",
               max: 20,
           },
           {
               name: "beamWavesHeight",
               text: "Beam waves, higher than (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "beamWavesPeriod",
               text: "with periods from (sec)",
               unit: "sec",
               connectedTo: "beamWavesHeight",
               max: 20,
           },
           {
               name: "followingWavesHeight",
               text: "Following waves, higher than (m)",
               unit: "m",
               max: 14,
           },
           {
               name: "followingWavesPeriod",
               text: "with periods from (sec)",
               unit: "sec",
               connectedTo: "followingWavesHeight",
               max: 20,
           },
           {
               name: "visibility",
               text: "Minimum visibility",
               dropdown: getVisibilityValueTexts()
           },
           {
               name: "icing",
               text: "Maximum risk of icing",
               dropdown: getIcingValueTexts()
           }
]

 // Mapping function for route planning
export function mapWeatherLimits(userAvoidData: weatherlimit, userWarnData: weatherlimit ): WeatherLimits {
    return {
    Waves: { avoid: userAvoidData.waves, warn: userWarnData.waves },
    SwellHeight: { avoid: userAvoidData.swellHeight, warn: userWarnData.swellHeight },
    HeadSwellHeight: { avoid: userAvoidData.headSwellHeight, warn: userWarnData.headSwellHeight },
    HeadSwellPeriod: {
        avoid: { max: userAvoidData.headSwellPeriod.max, min: userAvoidData.headSwellPeriod.min },
        warn: { max: userWarnData.headSwellPeriod.max, min: userWarnData.headSwellPeriod.min }
    },
    BeamSwellHeight: { avoid: userAvoidData.beamSwellHeight, warn: userWarnData.beamSwellHeight },
    BeamSwellPeriod: {
        avoid: { max: userAvoidData.beamSwellPeriod.max, min: userAvoidData.beamSwellPeriod.min },
        warn: { max: userWarnData.beamSwellPeriod.max, min: userWarnData.beamSwellPeriod.min }
    },
    FollowingSwellHeight: { avoid: userAvoidData.followingSwellHeight, warn: userWarnData.followingSwellHeight },
    FollowingSwellPeriod: {
        avoid: { max: userAvoidData.followingSwellPeriod.max, min: userAvoidData.followingSwellPeriod.min },
        warn: { max: userWarnData.followingSwellPeriod.max, min: userWarnData.followingSwellPeriod.min }
    },
    Wind10M: { avoid: userAvoidData.wind10M, warn: userWarnData.wind10M },
    Wind50M: { avoid: userAvoidData.wind50M, warn: userWarnData.wind50M },
    Visibility: { avoid: userAvoidData.visibility, warn: userWarnData.visibility },
    Icing: { avoid: userAvoidData.icing, warn: userWarnData.icing },
    Hurricanes: { avoid: userAvoidData.hurricanes, warn: userWarnData.hurricanes },
    TropicalStorms: { avoid: userAvoidData.tropicalStorms, warn: userWarnData.tropicalStorms },
    Depressions: { avoid: userAvoidData.depressions, warn: userWarnData.depressions },
    WindGusts10M: { avoid: userAvoidData.windGusts10M, warn: userWarnData.windGusts10M },
    WindGusts50M: { avoid: userAvoidData.windGusts50M, warn: userWarnData.windGusts50M },
    RiskWindSpeed: { avoid: userAvoidData.riskWindSpeed, warn: userWarnData.riskWindSpeed },
    RiskWaveHeight: { avoid: userAvoidData.riskWaveHeight, warn: userWarnData.riskWaveHeight },
    HeadWind: { avoid: userAvoidData.headWind, warn: userWarnData.headWind },
    BeamWind: { avoid: userAvoidData.beamWind, warn: userWarnData.beamWind },
    FollowingWind: { avoid: userAvoidData.followingWind, warn: userWarnData.followingWind },
    BeamWavesHeight: { avoid: userAvoidData.beamWavesHeight, warn: userWarnData.beamWavesHeight },
    BeamWavesPeriod: {
        avoid: { max: userAvoidData.beamWavesPeriod.max, min: userAvoidData.beamWavesPeriod.min },
        warn: { max: userWarnData.beamWavesPeriod.max, min: userWarnData.beamWavesPeriod.min }
    },
    HeadWavesHeight: { avoid: userAvoidData.headWavesHeight, warn: userWarnData.headWavesHeight },
    HeadWavesPeriod: {
        avoid: { max: userAvoidData.headWavesPeriod.max, min: userAvoidData.headWavesPeriod.min },
        warn: { max: userWarnData.headWavesPeriod.max, min: userWarnData.headWavesPeriod.min }
    },
    FollowingWavesHeight: { avoid: userAvoidData.followingWavesHeight, warn: userWarnData.followingWavesHeight },
    FollowingWavesPeriod: {
        avoid: { max: userAvoidData.followingWavesPeriod.max, min: userAvoidData.followingWavesPeriod.min },
        warn: { max: userWarnData.followingWavesPeriod.max, min: userWarnData.followingWavesPeriod.min }
    },
    IceConcentration: { avoid: userAvoidData.iceConcentration, warn: userWarnData.iceConcentration },
    MaxRollAngle: { avoid: userAvoidData.maxRollAngle, warn: userWarnData.maxRollAngle }
    };
}
